const profile = {
    name: 'Nome',
    avatar: 'Avatar',
    givenName: 'Nome',
    familyName: 'Sobrenome',
    middleName: 'Nome do meio',
    fullname: 'Nome completo',
    nickname: 'Apelido',
    preferredUsername: 'Nome de usuário preferido',
    profile: 'Perfil',
    website: 'Site',
    gender: 'Gênero',
    birthdate: 'Data de nascimento',
    zoneinfo: 'Fuso horário',
    locale: 'Localidade',
    address: {
        formatted: 'Endereço',
        streetAddress: 'Endereço',
        locality: 'Cidade',
        region: 'Estado/Província',
        postalCode: 'CEP',
        country: 'País',
    },
    gender_options: {
        female: 'Feminino',
        male: 'Masculino',
        prefer_not_to_say: 'Prefiro não dizer',
    },
};
export default Object.freeze(profile);
